import {DatePeriodEnum} from '../../../util/date';

import {
    ReviewsAndAnswersFilterQueriesEnum,
    ReviewsAndAnswersFilterStateType,
    ReviewsAndAnswersReviewFiltersType,
} from './reviews-and-answers-statistics-filter-type';

export const defaultReviewFilters: ReviewsAndAnswersReviewFiltersType = {
    [ReviewsAndAnswersFilterQueriesEnum.CatalogIds]: [],
    [ReviewsAndAnswersFilterQueriesEnum.Sentiments]: [],
    [ReviewsAndAnswersFilterQueriesEnum.TagIds]: [],
    [ReviewsAndAnswersFilterQueriesEnum.Rating]: [],
    [ReviewsAndAnswersFilterQueriesEnum.WithoutText]: '',
    [ReviewsAndAnswersFilterQueriesEnum.IsReplied]: '',
    [ReviewsAndAnswersFilterQueriesEnum.ActionReply]: '',
    [ReviewsAndAnswersFilterQueriesEnum.Target]: '',
    // Deleted reviews are excluded by default (sends in_trash=false).
    [ReviewsAndAnswersFilterQueriesEnum.IncludeDeleted]: false,
};

// Applied when the filters feature flag is off: no review filters and deleted
// reviews counted (IncludeDeleted true → in_trash=true) — the pre-feature behaviour.
export const legacyReviewFilters: ReviewsAndAnswersReviewFiltersType = {
    ...defaultReviewFilters,
    [ReviewsAndAnswersFilterQueriesEnum.IncludeDeleted]: true,
};

export const defaultFilterState: ReviewsAndAnswersFilterStateType = {
    [ReviewsAndAnswersFilterQueriesEnum.PeriodStart]: new Date(),
    [ReviewsAndAnswersFilterQueriesEnum.PeriodEnd]: new Date(),
    [ReviewsAndAnswersFilterQueriesEnum.Period]: DatePeriodEnum.Month,
    [ReviewsAndAnswersFilterQueriesEnum.CompareMode]: null,
    [ReviewsAndAnswersFilterQueriesEnum.ComparePeriodStart]: null,
    [ReviewsAndAnswersFilterQueriesEnum.ComparePeriodEnd]: null,
    ...defaultReviewFilters,
};
